import { Button, Dialog, Dropdown, InputText, classNames } from 'primereact'
import React, { useEffect, useState } from 'react'
import { Toast } from 'primereact/toast';
import { Checkbox } from '@mui/material';
import { ConfirmDialog } from 'primereact/confirmdialog';

import { toastShow } from '../../../../Services/ToastService';
import { getMenus } from '../../../../API/IT/Menu/MenuRequests'; 
import Loader from '../../../../Components/Loader/Loader';
import { useForm } from '../../../../Hooks/useForm'; 
import AutoCompleteDropdown from '../../../../Components/Form/AutoCompleteDropdown';

import { IUAccesoWebUser } from '../../../../API/IT/Accesos/AccesosRequests'; 

const AccesosCrud = ({ accesosDialog, setAccesosDialog, datos, toast, getAccesos, modo }) => {
  const initialValues = {
    IdAccess: -199,
    Access: "",
    ActiveApp: false,
    Activeweb: true,
    IdMenu: 0,
    Menu: '',
    Icon: '',
    URL: '',
    Descripcion:''
  }

  const [menu, setMenu] = useState([]);
  const [loading, setLoading] = useState(false);

  const onHide = () => {
    setAccesosDialog(false);
    resetForm()
  }

  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);  
  
  const getInfo = async () => {
      setLoading(true)
      const result = await getMenus();
      setMenu(result);
      setValues({
          ...datos,
          Menus: result.find((p) => datos?.IdMenu === p.IdMenu),
      })
      setValues((prevValues) => ({
        ...prevValues,
        Activeweb: prevValues.Activeweb || false,
        ActiveApp: prevValues.ActiveApp || false,
      }));

      setLoading(false);
  }

  const verificarInfo = () => {
      let error = {};
      if (!values.Access) {
        error.Access = true;
        error.error = true;
      }
      if (!values.Menus || !values.Menus.IdMenu) {
        error.IdMenu = true;
        error.error = true;
      }
      setError(error);
      // console.log(error);
      return error;
  };

  const agregarAcceso = async () => {
    setLoading(true);
      const e = verificarInfo();
      if (!e.error){
          const info = {
              IdAccess: values?.IdAccess,
              // Access: values?.Access.toLowerCase().replace(/\b\w+\b/g, (word) => {
              //     return word.length <= 3 ? word : word.charAt(0).toUpperCase() + word.slice(1);
              //   }),
              Access: values?.Access,
              IdMenu: values?.Menus.IdMenu,
              Activeweb: values?.Activeweb,
              ActiveApp: values?.ActiveApp,
              Descripcion: values?.Descripcion
            };
          const resultado = await IUAccesoWebUser(info);
          if (!resultado) {
              toastShow(toast, 'success', 'Creado', 'Informacion ingresada Correctamente.');
              getAccesos();
              setTimeout(() => {
                onHide();
              }, 1500);
              return true;
          }else{
              toastShow(toast, 'error', 'Error', 'Error al editar la informacion');
              return false;
          }

      }
      setLoading(false);
  }

  const DialogFooter = (
      <React.Fragment>
        <Button
          label="Cancelar"
          icon="pi pi-times"
          className="p-button-text"
          onClick={onHide}
        />
        <Button
          label={modo === "Crear" ? "Guardar" : "Modificar"}
          icon="pi pi-check"
          className="p-button-text"
          onClick={() => {
            if (modo === "Crear") {
              agregarAcceso();
            } else {
              agregarAcceso();
            }
          }}
          loading={loading}
        />
      </React.Fragment>
  );

  useEffect(() => {
    getInfo();
  }, [accesosDialog])

  const dialogTitle = modo === "Crear" ? "Agregar Acceso" : "Modificar Acceso"; 
  return (
    <div>
      <Dialog
        visible={accesosDialog}
        modal
        className="modal__contenedor modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
        style={{ width: "850px"}}
      >
        <div id="modalEditAccesos">
          <Loader loading={loading} querySelector={"#modalEditAccesos"} />
          <Toast ref={toast} />
          <ConfirmDialog />

          <div className="d-flex align-items-center">
            <h2 className="me-3">{dialogTitle}</h2>
          </div>
          <div className="modal__input-contenedor">
            <div className="field col-6 me-2">
              <span className="p-float-label">
                <InputText
                  name="Access"
                  value={values?.Access}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  abelStyle={{
                    color: "gray",
                    textShadow: "0px 0px 1px white",
                  }}
                  className={error.Access ? "p-invalid" : ""}
                />
                <label htmlFor="Access">Nombre</label>
              </span>
            </div>

            <div className="field col-6 me-2">
              <span className="p-float-label">
                <AutoCompleteDropdown
                  name={"Menus"}
                  value={values.Menus}
                  items={menu}
                  field={"Menu"}
                  label={"Menu"}
                  handleInputChange={handleInputChange}
                  className={error.IdMenu ? "p-invalid" : ""}
                  filterValue={values?.Estante}
                />
              </span>
            </div>
          </div>

          <div className="modal__input-contenedor">
            <div className="field col-6 me-2">
              <span className="p-float-label">
                <InputText
                  name="Descripcion"
                  value={values?.Descripcion}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  abelStyle={{
                    color: "gray",
                    textShadow: "0px 0px 1px white",
                  }}
                  className={error.Descripcion ? "p-invalid" : ""}
                />
                <label htmlFor="Descripcion">Descripción</label>
              </span>
            </div>
          </div>

          <div className="modal__input-contenedor">
            <div className="field col-6 me-2">
              <span className="p-float-label">
                <Checkbox
                  checked={values.Activeweb}
                  onChange={(e) =>
                    setValues({
                      ...values,
                      Activeweb: e.target.checked,
                    })
                  }
                />
                <label htmlFor="Activeweb">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Activeweb
                </label>
              </span>
            </div>

            <div className="field col-6 me-2">
              <span className="p-float-label">
                <Checkbox
                  checked={values.ActiveApp}
                  onChange={(e) =>
                    setValues({
                      ...values,
                      ActiveApp: e.target.checked,
                    })
                  }
                />
                <label htmlFor="ActiveApp" >
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ActiveApp
                </label>
              </span>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
}

export default AccesosCrud